"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.BOND_INSTRUMENT_TYPE = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const financial_contracts_1 = require("../financial-contracts");
const table_builder_1 = require("../table-builder");
exports.BOND_INSTRUMENT_TYPE = 'Bond';
function Definition(params) {
    let instrument;
    let instrumentParams;
    const tableBuilder = new table_builder_1.TableBuilderImp();
    if ((0, lodash_functions_1.isString)(params)) {
        instrument = {
            instrumentType: exports.BOND_INSTRUMENT_TYPE,
            instrumentDefinition: { instrumentCode: params },
        };
    }
    else {
        const { outputs, fields, pricingParameters, extendedParams } = params, paramsDefinition = __rest(params, ["outputs", "fields", "pricingParameters", "extendedParams"]);
        instrument = { instrumentType: exports.BOND_INSTRUMENT_TYPE, instrumentDefinition: Object.assign({}, paramsDefinition), pricingParameters };
        instrumentParams = { fields, outputs, extendedParams };
    }
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new financial_contracts_1.FinancialContractsProvider(session, tableBuilder);
            return financialContracts.getInstrumentAnalytics([instrument], instrumentParams);
        },
        /** @internal */
        getInstrument() {
            return instrument;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9maW5hbmNpYWwtY29udHJhY3RzL2JvbmQvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUVBLHdFQUE2RDtBQUM3RCx5RUFBaUU7QUFDakUsZ0VBQW9FO0FBQ3BFLG9EQUFtRDtBQUV0QyxRQUFBLG9CQUFvQixHQUFHLE1BQU0sQ0FBQztBQVEzQyxTQUFnQixVQUFVLENBQ3RCLE1BQW1EO0lBRW5ELElBQUksVUFBMkQsQ0FBQztJQUNoRSxJQUFJLGdCQUE4RSxDQUFDO0lBQ25GLE1BQU0sWUFBWSxHQUFHLElBQUksK0JBQWUsRUFBRSxDQUFDO0lBRTNDLElBQUksSUFBQSwyQkFBUSxFQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUM7UUFDbkIsVUFBVSxHQUFHO1lBQ1QsY0FBYyxFQUFFLDRCQUFvQjtZQUNwQyxvQkFBb0IsRUFBRSxFQUFFLGNBQWMsRUFBRSxNQUFNLEVBQUU7U0FDbkQsQ0FBQztJQUNOLENBQUM7U0FBTSxDQUFDO1FBQ0osTUFBTSxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUUsaUJBQWlCLEVBQUUsY0FBYyxLQUEwQixNQUFNLEVBQTNCLGdCQUFnQixVQUFLLE1BQU0sRUFBcEYsNERBQTJFLENBQVMsQ0FBQztRQUUzRixVQUFVLEdBQUcsRUFBRSxjQUFjLEVBQUUsNEJBQW9CLEVBQUUsb0JBQW9CLG9CQUFPLGdCQUFnQixDQUFFLEVBQUUsaUJBQWlCLEVBQUUsQ0FBQztRQUN4SCxnQkFBZ0IsR0FBRyxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsY0FBYyxFQUFFLENBQUM7SUFDM0QsQ0FBQztJQUVELE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ25DLE1BQU0sa0JBQWtCLEdBQUcsSUFBSSxnREFBMEIsQ0FBQyxPQUFPLEVBQUUsWUFBWSxDQUFDLENBQUM7WUFFakYsT0FBTyxrQkFBa0IsQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxFQUFFLGdCQUFnQixDQUFDLENBQUM7UUFDckYsQ0FBQztRQUNELGdCQUFnQjtRQUNoQixhQUFhO1lBQ1QsT0FBTyxVQUFVLENBQUM7UUFDdEIsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBOUJELGdDQThCQyJ9